import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { InputAccessoriesService } from 'src/app/services/input-accessories/input-accessories.service';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Injectable({
	providedIn: 'root',
})
export class KeyboardMapFeature {
	constructor(private logger: LoggerService, private keyboardService: InputAccessoriesService) {}

	public async getCapabililty(): Promise<boolean> {
		let hasCapability = false;
		this.logger.info('KeyboardMapFeature.hasCapability before API call');
		const response = await this.keyboardService.GetAllCapability();

		if (response !== undefined) {
			hasCapability = response?.keyboardMapCapability
				? response.keyboardMapCapability
				: false;
		}

		this.logger.info('KeyboardMapFeature.hasCapability hasCapability: ', hasCapability);

		return hasCapability;
	}
}
